// extracted by mini-css-extract-plugin
export var divider = "_1e-0";
export var dividerText = "_1e-1";